import { useEffect } from 'react';
import MultiSelect from 'common/data-entry/MultiSelect/MultiSelect';

import { ACTION_PERFORM, FRS_LOADED, FRS_READY, FRS_UNINITIALIZED } from 'components/eui/EuiFiltersContext/reducer';

import { GENERAL_INTEREST_ID } from '../constants';

import { initializeProcessor, setValueProcessor, syncCacheProcessor } from './patientDatabaseStudySiteProcessors';

export default function PatientDatabaseStudySiteMultiselect({ uniqKey, state, dispatch, getStudySites }) {
  const filterState = state[uniqKey];
  const filterCache = state.cache;
  const status = state.schema[uniqKey].status;
  const { studies, sites, selectedStudies, selectedSites } = filterState || {};

  useEffect(() => {
    if (status !== FRS_UNINITIALIZED) {
      return;
    }
    getStudySites().then(function(payload) {
      dispatch({
        type: ACTION_PERFORM,
        processor: initializeProcessor,
        payload: {
          key: uniqKey,
          ...payload
        }
      });
    });
  }, [uniqKey, dispatch, status, getStudySites]);

  useEffect(
    function() {
      if (status !== FRS_LOADED) {
        return;
      }

      dispatch({
        type: ACTION_PERFORM,
        processor: syncCacheProcessor,
        payload: filterCache
      });
    },
    [dispatch, uniqKey, status, filterCache]
  );

  if (status !== FRS_READY) return null;

  return (
    <>
      <MultiSelect
        data-testid="study-filter"
        label="Study"
        disabled={false}
        dataSource={studies}
        onChange={function(values) {
          dispatch({
            type: ACTION_PERFORM,
            processor: setValueProcessor,
            payload: {
              key: uniqKey,
              selectionType: 'Study',
              value: values
            }
          });
        }}
        value={selectedStudies}
        searchable={true}
        clearSearchOnSelection
        customFilterFunction={(e, index, collection, searchString) => {
          const searchTerm = e.id === GENERAL_INTEREST_ID ? e.name : `${e.projectCode} ${e.name}`;
          return searchTerm.toLowerCase().includes(searchString);
        }}
        customOptionTemplateFunction={e => (
          <div>
            {e?.id !== GENERAL_INTEREST_ID && (
              <div className="eui-filter-control-study-pcn-label">{e?.projectCode}</div>
            )}
            <div>{e?.name}</div>
          </div>
        )}
        className="patient-database-study-filter eui-filter-control-study-pcn"
        validate={false}
      />
      <MultiSelect
        data-testid="site-filter"
        label="Site"
        disabled={false}
        dataSource={sites}
        onChange={function(values) {
          dispatch({
            type: ACTION_PERFORM,
            processor: setValueProcessor,
            payload: {
              key: uniqKey,
              selectionType: 'Site',
              value: values
            }
          });
        }}
        value={selectedSites}
        searchable={true}
        clearSearchOnSelection
        validate={false}
      />
    </>
  );
}
